"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var preview_1 = require("../preview/preview");
var form_1 = require("../form/form");
var tabNav_1 = require("../form/tabNav");
var dialog_1 = require("./dialog");
var uploads_1 = require("./uploads");
var uploadDialog_1 = require("./uploadDialog");
var pngExport_1 = require("../export/pngExport");
var loaderAnimation_1 = require("./loaderAnimation");
var patternRestrict_1 = require("../helpers/patternRestrict");
var resizer_1 = require("../helpers/resizer");
var scroller_1 = require("../helpers/scroller");
var touchDetector_1 = require("../helpers/touchDetector");
var testFeatures_1 = require("../helpers/testFeatures");
var externalButton_1 = require("../helpers/externalButton");
var debug_1 = require("../helpers/debug");
var filter_1 = require("../helpers/filter");
var locale_1 = require("../helpers/locale");
var glyphMatcher_1 = require("./glyphMatcher");
var send_1 = require("./send");
var track_1 = require("./track");
var profanityFilter_1 = require("./profanityFilter");
var parse_1 = require("../helpers/parse");
var NgAnimate = require("angular-animate");
var NgFileUpload = require("ng-file-upload");
var NgClipboard = require("ngclipboard");
require("angular-hammer");
require("slick-carousel");
require("angular-slick-carousel");
var Book = /** @class */ (function () {
    function Book(config, form, formsCollection) {
        this.form = form;
        this.formsCollection = formsCollection;
        Object.assign(this, config.defaults);
        Object.defineProperty(this, 'form', { enumerable: false });
        Object.defineProperty(this, 'formsCollection', { enumerable: false });
    }
    Book.prototype.update = function (prefix, id, index, custom) {
        var forms = this.formsCollection.evaluate(this);
        var value = custom !== undefined ? custom : forms[prefix][id].options[index].value;
        this.form.select(prefix, id, index);
        this.set(prefix, id, value);
        this.resolve();
    };
    Book.prototype.getIndex = function (prefix, id) {
        var index = this.form.get(prefix, id);
        if (index) {
            return index;
        }
        var forms = this.formsCollection.evaluate(this);
        var options = forms[prefix][id].options;
        var value = this.get(prefix, id);
        index = 0;
        for (var _i = 0, options_1 = options; _i < options_1.length; _i++) {
            var option = options_1[_i];
            if (option.condition === true) {
                if (value === option.value) {
                    return index;
                }
                index++;
            }
        }
        index = 0;
        if (forms[prefix][id].type === 'radio-input') {
            for (var _a = 0, options_2 = options; _a < options_2.length; _a++) {
                var radioOption = options_2[_a];
                if (radioOption.condition === true) {
                    if (radioOption.custom) {
                        return index;
                    }
                    index++;
                }
            }
        }
        return 0;
    };
    Book.prototype.get = function (prefix, id) {
        if (!this.hasOwnProperty(prefix) || !this[prefix].hasOwnProperty(id)) {
            return '';
        }
        return this[prefix][id];
    };
    Book.prototype.set = function (prefix, id, value) {
        this[prefix][id] = value;
    };
    Book.prototype.resolve = function () {
        var options = this.formsCollection.evaluate(this);
        for (var _i = 0, _a = Object.entries(options); _i < _a.length; _i++) {
            var _b = _a[_i], groupName = _b[0], group = _b[1];
            for (var _c = 0, _d = Object.entries(group); _c < _d.length; _c++) {
                var _e = _d[_c], id = _e[0], form = _e[1];
                // Cannot resolve because there is no selection for entire form group
                if (!this.form.selected[groupName]) {
                    continue;
                }
                // No need to resolve because form has only one possible option
                if (form.options.length <= 1) {
                    continue;
                }
                var filteredOptions = parse_1.filterOptions(form.options);
                // NOTE: HERE MUST BE THAT DAM'N ...
                var index = this.form.selected[groupName][id];
                if (filteredOptions[index] && !filteredOptions[index].custom) {
                    var value = filteredOptions[index].value;
                    this.set(groupName, id, value);
                }
            }
        }
    };
    return Book;
}());
exports.Book = Book;
exports.default = angular.module('pb', [
    preview_1.default, form_1.default, tabNav_1.default, filter_1.default, dialog_1.default, uploads_1.default, uploadDialog_1.default, glyphMatcher_1.default,
    loaderAnimation_1.default, NgAnimate, NgFileUpload, NgClipboard, touchDetector_1.default, debug_1.default,
    patternRestrict_1.default, resizer_1.default, scroller_1.default, externalButton_1.default, send_1.default, track_1.default, locale_1.default, testFeatures_1.default,
    profanityFilter_1.default, pngExport_1.default, 'hmTouchEvents', 'slickCarousel'
])
    /*
     * The whenReady directive allows you to execute the content of a when-ready
     * attribute after the element is ready (i.e. when it's done loading all sub directives and DOM
     * content). See: http://stackoverflow.com/questions/14968690/sending-event-when-angular-js-finished-loading
     *
     * Execute multiple expressions in the when-ready attribute by delimiting them
     * with a semi-colon. when-ready="doThis(); doThat()"
     *
     * Optional: If the value of a wait-for-interpolation attribute on the
     * element evaluates to true, then the expressions in when-ready will be
     * evaluated after all text nodes in the element have been interpolated (i.e.
     * {{placeholders}} have been replaced with actual values).
     *
     * Optional: Use a ready-check attribute to write an expression that
     * specifies what condition is true at any given moment in time when the
     * element is ready. The expression will be evaluated repeatedly until the
     * condition is finally true. The expression is executed with
     * requestAnimationFrame so that it fires at a moment when it is least likely
     * to block rendering of the page.
     *
     * If wait-for-interpolation and ready-check are both supplied, then the
     * when-ready expressions will fire after interpolation is done *and* after
     * the ready-check condition evaluates to true.
     *
     * Caveats: if other directives exists on the same element as this directive
     * and destroy the element thus preventing other directives from loading, using
     * this directive won't work. The optimal way to use this is to put this
     * directive on an outer element.
     */
    .directive('whenReady', ['$interpolate', '$timeout', function ($interpolate, $timeout) {
        return {
            restrict: 'A',
            priority: Number.MIN_SAFE_INTEGER,
            link: function ($scope, $element, $attributes) {
                var expressions = $attributes.whenReady.split(';');
                var waitForInterpolation = false;
                var hasReadyCheckExpression = false;
                function evalExpressions(expressions) {
                    expressions.forEach(function (expression) {
                        $timeout(function () {
                            $scope.$eval(expression);
                        }, 50);
                    });
                }
                if ($attributes.whenReady.trim().length === 0) {
                    return;
                }
                if ($attributes.waitForInterpolation && $scope.$eval($attributes.waitForInterpolation)) {
                    waitForInterpolation = true;
                }
                if ($attributes.readyCheck) {
                    hasReadyCheckExpression = true;
                }
                if (waitForInterpolation || hasReadyCheckExpression) {
                    requestAnimationFrame(function checkIfReady() {
                        var isInterpolated = false;
                        var isReadyCheckTrue = false;
                        if (waitForInterpolation && $element.text().indexOf($interpolate.startSymbol()) >= 0) {
                            // if the text still has {{placeholders}}
                            isInterpolated = false;
                        }
                        else {
                            isInterpolated = true;
                        }
                        if (hasReadyCheckExpression && !$scope.$eval($attributes.readyCheck)) {
                            // if the ready check expression returns false
                            isReadyCheckTrue = false;
                        }
                        else {
                            isReadyCheckTrue = true;
                        }
                        if (isInterpolated && isReadyCheckTrue) {
                            evalExpressions(expressions);
                        }
                        else {
                            requestAnimationFrame(checkIfReady);
                        }
                    });
                }
                else {
                    evalExpressions(expressions);
                }
            }
        };
    }])
    .service('book', Book);
